import { createDenoisedTrack, isNoiseSuppressionSupported } from './noiseSuppression';

/**
 * Noise cancellation for a meeting's microphone: the same RNNoise denoiser the chat calls
 * use (utils/noiseSuppression.js), fitted to LiveKit as an audio track processor. It sits
 * on top of the browser's own cleaning, and if it cannot start the plain microphone
 * simply carries on.
 */

const KEY = 'gts:meeting:noiseSuppression';

export const isMeetingDenoiseSupported = isNoiseSuppressionSupported;

/** On unless this person switched it off - and the choice is remembered, as it is for calls. */
export const storedMeetingDenoise = () => {
    try { return localStorage.getItem(KEY) !== 'off'; } catch { return true; }
};

export const rememberMeetingDenoise = (on) => {
    try { localStorage.setItem(KEY, on ? 'on' : 'off'); } catch { /* private mode */ }
};

export const createDenoiseProcessor = () => {
    let handle = null;
    const processor = {
        name: 'rnnoise',
        processedTrack: undefined,
        async init({ track }) {
            handle = await createDenoisedTrack(track);
            processor.processedTrack = handle.track;
        },
        // The microphone changed (a headset was plugged in): clean the new one.
        async restart({ track }) {
            handle?.dispose();
            handle = await createDenoisedTrack(track);
            processor.processedTrack = handle.track;
        },
        async destroy() {
            handle?.dispose();
            handle = null;
            processor.processedTrack = undefined;
        }
    };
    return processor;
};
